import React, { useContext, useEffect, useState } from "react";
import { Text } from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/modals/ModalSelectStoreAndSection";
import {
  ContStep,
  BtnGeneral,
  ModalContainer,
} from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/modal-post-product/ModalContStyles";
import { GlobalContext } from "../../../../../../contexts/GlobalContext";
import SetParamProdToPost from "./SetParamProdToPost";
import ViewProductsAfterToPost from "./ViewProductsAfterToPost";
import ViewsBeforeToSend from "./ViewsBeforeToSend";
import axios from "axios";
import {
  keyAccessToken,
  keyUserId,
} from "../../../../../../assets/js/SessionStorageNames";
import { Col, Container, Row } from "react-bootstrap";
import { apiRoutes } from "../../../../../../config";
import SelectFlCategory from "./SelectFlCategory";
import { publishToFalabella } from "../../../../../../hooks/api/falabella";

export const LayoutHeaderButtons = ({ back, close, next, text }) => {
  return (
    <Container>
      <Row>
        <Col xs={6}>
          <Text size='15pt' fw='500'>
            {text || ''}
          </Text>
        </Col>
        <Col xs={2}>{back}</Col>
        <Col xs={2}>{next}</Col>
        <Col xs={2}>{close}</Col>
      </Row>
    </Container>
  );
};

export default function LayoutModalFl({
  currentStep,
  setCurrentStep,
  defaultPlugin,
  currentPlugin,
}) { 
  const globalContext = useContext(GlobalContext);
  const [msgSuccess, setMsgSuccess] = useState("");
  const [category, setcategory] = useState(null);
  const [isLoad, setIsLoad] = useState(true);
  const [paramsToSend, setParamsToSend] = useState([]);
  const [listinType, setListinType] = useState(null);
  const [publishGroup, setPublishGroup] = useState(null);
  const [officialStoreName, setOfficialStoreName] = useState([]);
  const [stores, setStores] = useState(null);
  const [data, setData] = useState([]);
  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [descriptionTemplate, setDescriptionTemplate] = useState(null);
  const [requiredAttributes, setRequiredAttributes] = useState([]);

  //? valida que todos los atributos obligatorios de la categoria y la marca esten llenos en cada producto
  const validateRequiredFields = () => {
    const errors = [];
    for (const prod of paramsToSend) {
      const missing = requiredAttributes
        .filter((attr) => {
          const group = attr.GroupName === "Variation"
            ? prod.categoryAttributes?.variation
            : prod.categoryAttributes?.general;
          const value = group?.[attr.FeedName];
          return value === undefined || value === null || value.toString().trim() === "";
        })
        .map((attr) => attr.Label || attr.FeedName);

      //? la marca debe venir del catalogo de Falabella ({ brandId, name }): el backend
      //? publica Brand.name y sin ese objeto envia "Sin Marca", que Falabella rechaza
      if (!prod.Brand?.name || prod.Brand.name.toString().trim() === "") {
        missing.unshift("Marca de Producto");
      }

      if (missing.length > 0) {
        errors.push(`${prod.sku || prod.Title}: ${missing.join(", ")}`);
      }
    }
    return errors;
  };

  /**
   * Handle the axios error
   * @param {Error} err The thrown error
   * @param {string} msg A message to show in the modal
   * @param {boolean} consoleLog If should log the error in the console
   */
  const handleAxiosError = (err, msg = null, consoleLog = true) => {
    if (axios.isCancel(err)) return; //Don't show axios cancel error
    if (err.response && err.response.data) {
      if (err.response.data.message) {
        globalContext.showModalWithMsg(err.response.data.message);
      } else {
        globalContext.showModalWithMsg(err.response.data);
      }
    } else if (msg) {
      globalContext.showModalWithMsg(msg);
    }

    if (consoleLog) console.log("Error: ", err, "Response: ", err.response);
  };

  useEffect(() => {
    if (!globalContext.modalPostProduct) return;
  }, [globalContext.pluginSearchForpost, globalContext.modalPostProduct]);


  //? obtenemos la descripcion
  useEffect(() => {
    console.log('Obtenemos la desc')
    if (!globalContext.modalPostProduct) return;
    const entId = globalContext.currentEnterpriseId;
    if (!entId) return;
    if (currentPlugin !== "fl") return;
    getDescriptionProduct(entId)
      .then((resp) => {
        if (
          resp.data.data.configData.descriptionTemplate ||
          resp.data.data.configData.descriptionTemplateAnicam
        ) {
          setDescriptionTemplate(resp.data.data.configData.descriptionTemplate);
        } else {
          handleAxiosError(
            "",
            "Para poder publicar es necesario una plantilla para la descripcion"
          );
        }
      })
      .catch((err) => {
        console.log("aqui", err);
        setDescriptionTemplate("");
        handleAxiosError(
          err,
          "Ocurrio un Error al cargar la plantilla de publicacion"
        );
      });
  }, [
    globalContext.currentEnterpriseId,
    globalContext.modalPostProduct,
    globalContext.pluginSearchForpost,
    currentPlugin,
  ]);

  //? validamos y seteamos el arreglo de parametros a enviar
  useEffect(() => {
    if (!globalContext.modalPostProduct) return;
      if (currentPlugin !== "fl") return;
      if (!descriptionTemplate) return;
      pushDataInParamsToSend();
  }, [
    globalContext.modalPostProduct,
    globalContext.pluginSearchForpost,
    currentPlugin,
    descriptionTemplate,
  ]);

  const buildListSku = async (listProd) => {
    let listSku = [];
    for (const prod of listProd) {
      listSku.push(prod.sku);
    }
  };

  const renderLabelStepML = () => {
    switch (currentStep) {
      case 2:
        return "Seleccione la categoria";
      case 3:
        return "Modifique los valores";
      case 4:
        return "Ultimo paso";
      case 5:
        return "Proceso culminado";
      default:
        break;
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 2:
        return (
          <SelectFlCategory
            isLoad={isLoad}
            setIsLoad={setIsLoad}
            setCategory={setcategory}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 3:
        return (
          <SetParamProdToPost
            isLoad={isLoad}
            setIsLoad={setIsLoad}
            paramsToSend={paramsToSend}
            setParamsToSend={setParamsToSend}
            listinType={listinType}
            publishGroup={publishGroup}
            setListinType={setListinType}
            setPublishGroup={setPublishGroup}
            validateInput={validateInput}
            category={category}
            setRequiredAttributes={setRequiredAttributes}
          />
        );
      case 4:
        return (
          <ViewsBeforeToSend
            isLoad={isLoad}
            setIsLoad={setIsLoad}
            paramsToSend={paramsToSend}
            setParamsToSend={setParamsToSend}
            listinType={listinType}
            publishGroup={publishGroup}
            officialStoreName={officialStoreName}
            setOfficialStoreName={setOfficialStoreName}
            stores={stores}
          />
        );
      case 5:
        return (
          <ViewProductsAfterToPost
            isLoad={isLoad}
            data={data}
          />
        );
      default:
        return (
          <SelectFlCategory
            category={category}
            setcategory={setcategory}
            isLoad={isLoad}
            setIsLoad={setIsLoad}
            setCurrentStep={setCurrentStep}
          />
        );
    }
  };

  const getDescriptionProduct = (entId) => {
    return axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/v1/plugin-config/${entId}/odoo`,
      {
        cancelToken: axiosCancelTokenSource.token,
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
      }
    );
  };

  const setDescriptionToPost = (desc) => {
    return desc.replace(/<[^>]*>?/g, " ");
  };



  function validateInput(txt) {
    // se convierte el dato recibido en string
    txt = txt.toString();
    // Eliminar caracteres no deseados
    let resultado = txt.replace(/[^0-9.]/g, '');
    // Validar cantidad de caracteres después del punto
    let puntoIndex = resultado.indexOf('.');
    if (puntoIndex !== -1) {
      let caracteresDespuesDelPunto = resultado.substring(puntoIndex + 1);
      if (caracteresDespuesDelPunto.length > 2) {
        caracteresDespuesDelPunto = caracteresDespuesDelPunto.substring(0, 2);
      }
      resultado = resultado.substring(0, puntoIndex + 1) + caracteresDespuesDelPunto;
    }
    // Validar cantidad de puntos
    let puntosCount = resultado.split('.').length - 1;
    if (puntosCount > 1) {
      resultado = resultado.replace(/\./g, '');
    }
    return resultado;
  }//aqui xd
  //? push data in the paramsToSend
  const pushDataInParamsToSend = () => {
    console.log('push data in params to send')
    console.log(globalContext.listProductsToSend)

    //? validamos si el array del context no es vacio
    if (globalContext.listProductsToSend.length > 0) {
      let copyArr = paramsToSend;
      //? recorremos el array
      for (const v of globalContext.listProductsToSend) {
        //? despues seteamos los parametros 
        copyArr.push({
          _id: v._id,
          sku: v.sku,
          Title: v.title.substring(0, 60),
          Price: v.price,
          Description: setDescriptionToPost(v.description),
          Brand: v.brand,
          PackagedHeight: v.height != 0 ? v.height : null,
          PackagedLength: v.lenght != 0 ? v.lenght : null,
          PackagedWidth: v.width != 0 ? v.width : null,
          PackagedWeightKg: v.weight != 0 ? v.weight : null,

        });
      }

      setParamsToSend(copyArr);
    }
  };



  const publishProductsToFalabella = async () => {
    const enterpriseId = globalContext.currentEnterpriseId;
    if (!enterpriseId) {
      globalContext.showModalWithMsg("Error: No se ha seleccionado una empresa");
      return;
    }

    // Se revalida antes de enviar: el usuario puede volver al paso 3 y dejar campos vacios
    const missingFields = validateRequiredFields();
    if (missingFields.length > 0) {
      globalContext.showModalWithMsg(
        `No se puede publicar, faltan campos obligatorios — ${missingFields.join(" | ")}`
      );
      return;
    }

    // Resetear el estado data para evitar usar datos del proceso anterior
    setData([]);
    setIsLoad(false);
    setCurrentStep(currentStep + 1);

    try {
      const dataForFalabella = await publishToFalabella(enterpriseId, paramsToSend, category, publishGroup);
      console.log(dataForFalabella?.data?.data, 'dataForFalabella000000000000')
      
      // ✅ VALIDACIÓN MEJORADA
      const responseData = dataForFalabella?.data?.data;
      if (!responseData) {
        throw new Error('No se recibieron datos de la respuesta');
      }
      
      // Validar que existe processMonitorId
      if (!responseData.processMonitorId && !responseData.monitor) {
        console.error('No se encontró processMonitorId en la respuesta:', responseData);
        throw new Error('No se pudo obtener el ID del proceso de monitoreo');
      }
      
      // Usar el campo correcto (monitor o processMonitorId)
      const processMonitorId = responseData.processMonitorId || responseData.monitor;
      
      setData({
        ...responseData,
        processMonitorId: processMonitorId
      });
      setIsLoad(true);
    } catch (error) {
      setIsLoad(true);
      console.error("error al publicar", error);
      // Mostrar error al usuario
      globalContext.showModalWithMsg(`Error al publicar productos: ${error.message}`);
    }
  };

  const renderBtnStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div
            className='d-flex justify-content-between align-items-center'
          >
            <LayoutHeaderButtons
              text={renderLabelStepML()}
              close={
                <BtnGeneral
                  bgc='#7367F0'
                  color='#FFF'
                  onClick={() => globalContext.setModalPostProduct(false)}
                >
                  Cerrar
                </BtnGeneral>
              }
            />
          </div>
        );
      case 2:
        return (
          <div
            className='d-flex justify-content-between align-items-center'
          >
            <LayoutHeaderButtons
              text={renderLabelStepML()}
              back={
                <BtnGeneral
                  bgc='#F3F2F7'
                  color='#979797'
                  onClick={() => {
                    setCurrentStep(currentStep - 1);
                    defaultPlugin();
                  }}
                >
                  Volver
                </BtnGeneral>
              }
              close={
                <BtnGeneral
                  bgc='#7367F0'
                  color='#FFF'
                  onClick={() => globalContext.setModalPostProduct(false)}
                >
                  Cerrar
                </BtnGeneral>
              }
            />
          </div>
        );
      case 3:
        console.log(`paramsToSend.length: ${paramsToSend.length}`);
        console.log(`paramsToSend: ${JSON.stringify(paramsToSend)}`);
        
        return (
          <div
            // style={{ width: 500, height: "auto" }}
            className='d-flex justify-content-between align-items-center'
          >
            <LayoutHeaderButtons
              text={renderLabelStepML()}
              back={
                <BtnGeneral
                  bgc='#F3F2F7'
                  color='#979797'
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  Volver
                </BtnGeneral>
              }
              next={
                  <BtnGeneral
                    onClick={() => {
                      const missingFields = validateRequiredFields();
                      if (missingFields.length > 0) {
                        globalContext.showModalWithMsg(
                          `Faltan campos obligatorios para publicar — ${missingFields.join(" | ")}`
                        );
                        return;
                      }
                      setCurrentStep(currentStep + 1);
                    }}>
                    Siguiente
                  </BtnGeneral>
              }
              close={
                <BtnGeneral
                  bgc='#7367F0'
                  color='#FFF'
                  onClick={() => globalContext.setModalPostProduct(false)}
                >
                  Cerrar
                </BtnGeneral>
              }
            />
          </div>
        );
      case 4:
        return (
          <div
            // style={{ width: 500, height: "auto" }}
            className='d-flex justify-content-between align-items-center'
          >
            <LayoutHeaderButtons
              text={renderLabelStepML()}
              back={
                <BtnGeneral
                  bgc='#F3F2F7'
                  color='#979797'
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  Volver
                </BtnGeneral>
              }
              next={
                <BtnGeneral onClick={publishProductsToFalabella}>
                  Publicar
                </BtnGeneral>
              }
              close={
                <BtnGeneral
                  bgc='#7367F0'
                  color='#FFF'
                  onClick={() => globalContext.setModalPostProduct(false)}
                >
                  Cerrar
                </BtnGeneral>
              }
            />
          </div>
        );
      case 5:
        return (
          <div
            // style={{ width: "100%", height: "auto" }}
            className='d-flex justify-content-center align-items-center'
          >
            <LayoutHeaderButtons
              text={renderLabelStepML()}
              back={
                <BtnGeneral
                  bgc='#F3F2F7'
                  color='#979797'
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  Volver
                </BtnGeneral>
              }
              close={
                <BtnGeneral
                  bgc='#7367F0'
                  color='#FFF'
                  onClick={() => globalContext.setModalPostProduct(false)}
                >
                  Cerrar
                </BtnGeneral>
              }
            />
          </div>
        );
      default:
        break;
    }
  };

  const getEnterpriseConfig = () => {

    const entId = globalContext.currentEnterpriseId;
    if (!entId) return;
    const axiosCancelTokenSource = axios.CancelToken.source();
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/plugin-config/${entId}/ml`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data.configData;
        setPublishGroup(data.publishVariantsGroupOdooMl);
      })
      .catch((err) =>
        handleAxiosError(
          err,
          "Disculpe, no se pudo cargar la configuracion actual."
        )
      );
  };

  //? obtenemos las marcas
  useEffect(() => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) return; 
    axios
      .get(`${apiRoutes.cashea.merchantsNames}/${entId}`, {
        cancelToken: axiosCancelTokenSource.token,
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
        params:{
          enterpriseId: entId,
          name: 'all'
        }
      })
      .then((resp) => {
        const brands = Object.values(resp.data.data);
        setStores(brands || []);
      })
      .catch((err) => handleAxiosError(err));
  }, [globalContext.currentEnterpriseId]);

  //? al cerrar la modal
  useEffect(() => {
    if (!globalContext.modalPostProduct) {
      setCurrentStep(1);
      setMsgSuccess("");
      setIsLoad(true);
      setcategory(null);
    }
  }, [globalContext.modalPostProduct]);

  useEffect(() => {
    getEnterpriseConfig();
  }, []);

  return (
    <ModalContainer>
      <div
        style={{
          width: "100%",
          // display: "flex",
          justifyContent: "space-between",
        }} 
      >
        {renderBtnStep()}
      </div>

      <ContStep>{renderStep()}</ContStep>
    </ModalContainer>
  );
}
